/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core"
import React, { useEffect, useState, useRef } from "react"
import { SITE_BASE_URL } from "../common/constants"
import { UpgradeIcon } from "../LandingHeader/Feedback/icons/Icons"
import { useSelector } from "react-redux";
import { fetchBlockedSitesData } from "../action/common";
import { loadOutseta } from "../Outseta";

const PreExpire = ({data, theme, isFreeTrial, isSubscriptionExpired, isFreeTrialExpired}) => {
    const planUpgradeRef = useRef(null);
    const {focusSessions} = useSelector(state => state.focusTimer);
    const {taskList} = useSelector(state => state.task);
    const [focusTime, setFocusTime] = useState(0);
    const [totalTasks, setTotalTasks] = useState(0);
    const [totalBlockedSites, setTotalBlockedSites] = useState(0);
    const [totalInCompletedTasks, setTotalInCompletedTasks] = useState(0);
    const hash = window.location?.hash ? window.location.hash.replace('#', '') : null;

    const OPTIONS = {
        domain: "lifetab.outseta.com",
        load: "profile"
    };

    useEffect(() => {
        if(window?.chrome?.storage){
            return;
        }

        // document.body.classList.remove('dark')
        // document.body.classList.remove('light')
        // document.body.classList.add(theme);
        document.body.classList.add('plan-expired')
       // document.body.style.setProperty('--accent-color-app', 'var(--accent-color)');

        loadOutseta(OPTIONS).then((response) => {
            // Initialize Outseta with your access token
            response.setAccessToken(localStorage.getItem('token'));

            response.on('subscription.update', (event) => {
                setTimeout(() => {
                    window.location.href = `${SITE_BASE_URL}${process.env.REACT_APP_ROOT}?access_token=${response.getAccessToken()}`
                    response.profile.close();
                }, 2000)
            })

            // Trigger upgrade plan button click if coming from planChange page
            if(hash == 'upgradePlan'){
                setTimeout(() => {
                    planUpgradeRef.current.click();
                }, 2000)
            }
        });

        return () => {
            document.body.classList.remove('plan-expired')
        };
    }, [])

    // useEffect(() => {
    //     document.body.classList.remove('dark')
    //     document.body.classList.remove('light')
    //     document.body.classList.add(theme);
    // }, [theme])

    useEffect(() => {
        const totalTime = calculateTotalTime(focusSessions);
        setFocusTime(totalTime);
    }, [focusSessions])

    useEffect(() => {
        const totalTasks = taskList.filter(task => task.taskSource === null && !task?.deletedAt);
        const totalInCompletedTasks = totalTasks.filter(task => task.status != '1' && !task?.deletedAt);
        setTotalTasks(totalTasks.length);
        setTotalInCompletedTasks(totalInCompletedTasks.length);
        fetchBlockedSitesData().then(response => {
            setTotalBlockedSites(response.blockCount);
        })
    }, [taskList])

    const calculateTotalTime = (data) => {
        let totalMilliseconds = 0;
        let pauseDuration = 0;
        data.map((session) => {
            let lastPause = 0;
            session?.pauses.map(pause => {
                pauseDuration += pause.endTime - pause.startTime;
                lastPause = pause;
            });

            totalMilliseconds += (session.endTime ? session.endTime : (lastPause?.endTime ?? session.startTime)) - session.startTime;
        });

        return (totalMilliseconds - pauseDuration) / 1000
    }

    const insertError = () => {
        const intervalId = setInterval(() => {
            if(document.querySelector('.o--SectionGroup--sectionGroup')){
                clearInterval(intervalId);
                document.querySelector('.o--SectionGroup--sectionGroup').insertAdjacentHTML('afterend', '<div class="o--ErrorMessages--errorMessages o--ErrorMessages--single o--ErrorMessages--cornerShape-rounded"><ul><li>Your subscription has expired, please choose a new plan.</li></ul></div>');
            }
        }, 100);
    }

    const checkIfProcessed = (e) => {
        if(e.target.getAttribute('o-processed') === '1') {
            return true;
        }

        e.preventDefault();
        e.stopPropagation();
    }

    return (
        <>
            <div className='flex relative py-10 px-[35px] gap-[10px] flex-col border-b border-black/5 dark:border-white/5'>
                <div className={`font text-50 font-['RL_Madena'] font-normal`}>
                    {
                        isFreeTrialExpired
                        ?
                        <span className='darkPrimaryColor'>Your trial has expired.</span>    
                        :
                        (
                            isSubscriptionExpired
                            ?
                            <span className='darkPrimaryColor'>Your subscription has expired.</span>    
                            :
                            <><span className='darkPrimaryColor'>Your trial expires {data?.daysLeft === 0 ? '' : 'in'} </span>{typeof data?.daysLeft != 'undefined' && <span className="accent-text-color">{data?.daysLeft === 0 ? ' Today' : `${data?.daysLeft} ${data?.daysLeft > 1 ? 'days' : 'day'}`}</span>}</>
                        )
                    }
                </div>
                <div className="flex flex-col gap-[5px]">
                    <p className="font text-[14px] font-inter opacity-50 dark:text-white/50">Upgrade now to secure one of only 1,000 spots in our Early Supporter Plan.</p>
                    <p className="font text-[14px] font-inter font-medium accent-text-color">Lock in our lowest pricing forever and continue enjoying a calmer, science-based take on productivity.</p>
                    <p className="font text-xs font-inter font italic opacity-50 dark:text-white/50">Have any questions? Get in touch by sending an email to <a href="mailto:support@lifetab.co text-black dark:text-white">support@lifetab.co</a></p>
                </div>
            </div>
            <div className="flex relative p-[30px] gap-5 items-center w-full border-b border-black/5 dark:border-white/5">
                <UpgradeIcon color='var(--accent-color)' fill='var(--accent-color)' id='upgrade-icon-1' />
                <div className="flex gap-[10px]">
                    <span className={`darkPrimaryColor font text-2xl font-['RL_Madena'] font-normal`}>$6/Month</span>
                    <span className={`font text-2xl font-['RL_Madena'] font-normal opacity-50 dark:text-white/50`}>Early Supporter Plan</span>
                </div>
                <div style={{flex: '1 0 0px', alignSelf: 'stretch'}}></div>
                {
                    window?.chrome?.storage
                    ?
                    <a href={`${SITE_BASE_URL}/subscription-plan#upgradePlan`} className='button primary' style={{background: 'var(--accent-color)', color: '#fff'}}><UpgradeIcon color='white' fill='none' gradient={false} id='upgrade-icon-2' strokeWidth={2} width={15.184} height={15.184} /> Upgrade</a>
                    :
                    <a onClick={checkIfProcessed} ref={planUpgradeRef} href="https://lifetab.outseta.com/profile?tab=planChange&stateProps=%7B%22planUid%22%3A%227maO3G9E%22%2C%22planPaymentTerm%22%3A%22monthly%22%2C%22discountCode%22%3A%22EarlySupporter%22%7D#o-authenticated" className='button primary' style={{background: 'var(--accent-color)', color: '#fff'}}><UpgradeIcon color='white' fill='none' gradient={false} id='upgrade-icon-2' strokeWidth={2} width={15.184} height={15.184} /> Upgrade</a>
                }
            </div>
            <div className="p-5 relative">
                <div className="p-5 flex gap-5 flex-col items-start justify-start">
                    <div className={`font text-[14px] font-inter font-normal opacity-50 dark:text-white/50`}>Your journey with LifeTab so far ...</div>
                    <div className={`flex justify-between items-center w-full font-['RL_Madena'] font-normal`}>
                        <div className="flex gap-[2px] flex-col items-center accent-text-color">
                            <span className="font text-6xl">{totalTasks}</span>
                            <span className="font text-[14px]">Tasks created</span>
                        </div>
                        <div className="flex gap-[2px] flex-col items-center accent-text-color">
                            <span className="font text-6xl">{totalInCompletedTasks}</span>
                            <span className="font text-[14px]">Incomplete tasks</span>
                        </div>
                        <div className="flex gap-[2px] flex-col items-center accent-text-color">
                            <span className="font text-6xl">{totalBlockedSites}</span>
                            <span className="font text-[14px]">Site blocked</span>
                        </div>
                        <div className="flex gap-[2px] flex-col items-center accent-text-color">
                            <span className="font text-6xl">{Math.round(focusTime / 60)}</span>
                            <span className="font text-[14px]">mins spent focused</span>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default PreExpire